import React from 'react';
import {
  FieldCheckbox,
  FieldRadioButton,
  FieldSelect,
  FieldTextInput,
} from '../../components';
import * as validators from '../../util/validators';
import css from './CheckoutCustomFields.css';

const CheckoutCustomFields = props => {
  const { additionalFields = null, intl, needsTranslation = false } = props;

  if (!additionalFields || !additionalFields.fields || !additionalFields.fields.length) return null;

  const requiredMessage = intl.formatMessage({
    id: "StripePaymentForm.validateRequired",
  });
  const checkboxValue = intl.formatMessage({
    id: "StripePaymentForm.checkboxValue",
  });

  const selectPlaceholder = intl.formatMessage({ id: "StripePaymentForm.selectPlaceholder" });
  const requiredValidation = validators.required(requiredMessage);
  const { composeValidators, nonEmptyArray } = validators;

  return (
    <>
      {additionalFields.fields.map((field, index) => {
        const { label, name, options, placeholder, required = true, type, value, disabled, fieldValidator, fieldTransformer } = field;

        const translatedLabel = needsTranslation ? intl.formatMessage({ id: label }) : label;
        const translatedPlaceholder = needsTranslation ? intl.formatMessage({ id: placeholder }) : placeholder;

        const validation = required ? requiredValidation : null;
        const optionalLabel = `${translatedLabel}${required ? "*" : ""}`;

        if (type === "select") return (
          <FieldSelect
            className={css.message}
            id={name}
            key={name}
            label={optionalLabel}
            name={`checkoutFields.${name}`}
            validate={validation}
          >
            <option disabled={required} value="">
              {selectPlaceholder}
            </option>
            {options.map((option, i) => {
              if (typeof option === 'string') {
                return (
                  <option key={option} value={option}>
                    {option}
                  </option>
                );
              } else {
                return (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                );
              }
            })}
          </FieldSelect>
        );

        if (type === "checkbox") return (
          <div key={index}>
            <p>{optionalLabel}</p>
            <FieldCheckbox
              id={name}
              name={`checkoutFields.${name}`}
              label={translatedPlaceholder}
              value={checkboxValue}
              validate={required ? composeValidators(nonEmptyArray(requiredMessage)) : null}
            />
          </div>
        );

        if (type === "radio") return (
          <div key={index}>
            <p>{optionalLabel}</p>
            <div>
              {
                options.map((option, i) => (
                  <FieldRadioButton
                    id={option}
                    key={i}
                    label={option}
                    name={`checkoutFields.${name}`}
                    validate={validation}
                    value={option}
                  />
                ))
              }
            </div>
          </div>
        );

        const parse = fieldTransformer ? (value) => fieldTransformer(value) : (value) => value;

        return (
          <FieldTextInput
            className={css.message}
            id={name}
            key={name}
            label={optionalLabel}
            name={`checkoutFields.${name}`}
            placeholder={translatedPlaceholder}
            type="text"
            validate={fieldValidator ? composeValidators(validation, fieldValidator('Error')) : validation}
            disabled={disabled}
            parse={parse}
          />
        )
      })}
    </>
  );
};

export default CheckoutCustomFields;
